import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import colors from 'hsl-shared-components/lib/Theme/colors';
import CardReaderButton from '../../components/CardReaderButton';
import CurrentZoneIndicator from '../../components/CurrentZoneIndicator';
import {
  getRelativeHeight,
  getRelativeWidth,
} from '../../components/CardReader/CardReader';

const BackButton = styled(CardReaderButton)`
  position: absolute;
  top: ${getRelativeHeight(36)};
  left: ${getRelativeHeight(4)};
  height: ${getRelativeHeight(49)};
  width: ${getRelativeWidth(49)};
`;

const AddPassengersButton = styled(CardReaderButton)`
  position: absolute;
  top: ${getRelativeHeight(36)};
  right: ${getRelativeHeight(3)};
  height: ${getRelativeHeight(50)};
  width: ${getRelativeWidth(94)};
`;

const TicketArea = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  top: ${getRelativeHeight(90)};
  left: ${getRelativeHeight(4)};
  right: 50%;
  bottom: ${getRelativeHeight(35)};
  cursor: pointer;
`;

const TicketZone = styled.div`
  top: ${getRelativeHeight(73)};
  left: ${getRelativeWidth(25)};
  color: ${colors.primary.hslGreyDark};
  font-size: 2.25em;
  font-weight: 700;
`;

const Multiplier = styled.span`
  font-size: 1.5em;
  color: ${colors.primary.hslGreyDark};
  font-weight: 200;
  margin: 0 0.3em 0 0.3em;
`;

const TicketPassengers = styled(TicketZone)``;

const PurchaseScreenContent = ({
  currentZone,
  ticketZones,
  ticketPassengers,
  onBackButtonClick,
  onAddPassengersClick,
  onTicketAreaClick,
}) => (
  <>
    <CurrentZoneIndicator>{currentZone[0]}</CurrentZoneIndicator>
    <BackButton onClick={onBackButtonClick} />
    <AddPassengersButton onClick={onAddPassengersClick} />
    <TicketArea onClick={onTicketAreaClick}>
      <TicketZone>{ticketZones}</TicketZone>
      <Multiplier>X</Multiplier>
      <TicketPassengers>{ticketPassengers}</TicketPassengers>
    </TicketArea>
  </>
);

PurchaseScreenContent.propTypes = {
  currentZone: PropTypes.string.isRequired,
  ticketZones: PropTypes.string.isRequired,
  ticketPassengers: PropTypes.number.isRequired,
  onBackButtonClick: PropTypes.func.isRequired,
  onAddPassengersClick: PropTypes.func.isRequired,
  onTicketAreaClick: PropTypes.func.isRequired,
};

export default PurchaseScreenContent;
